import { useDispatch } from '@redux';
import { forgotPasswordUser } from '@redux/auth/actions';
import { Button, Form, Input } from 'antd';
import PublicHeader from 'layout/PublicLayout/PublicHeader';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function VerificationEmail({ setStep, setData }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleVerify = (values) => {
    setLoading(true);
    dispatch(forgotPasswordUser(values)).then(({ payload }) => {
      setLoading(false);
      if (payload?.success) {
        setData({ email: values.email });
        setStep('otp');
      }
    });
  };

  return (
    <div>
      <PublicHeader title="common.auth.forgotPassword" />
      <Form onFinish={handleVerify} layout="vertical">
        <Form.Item
          name="email"
          label={t('input.verificationEmail.label')}
          rules={[
            {
              required: true,
              message: t('input.verificationEmail.validateMsg.required'),
            },
            {
              type: 'email',
              message: t('input.verificationEmail.validateMsg.invalid'),
            },
          ]}
        >
          <Input placeholder={t('input.verificationEmail.placeholder')} />
        </Form.Item>

        <Button
          htmlType="submit"
          type="primary"
          className="mt-[10px] w-full"
          loading={loading}
        >
          {t('button.resetMyPassword')}
        </Button>
        <Button
          htmlType="button"
          className="mt-[10px] w-full"
          onClick={() => navigate('/login')}
        >
          {t('button.backToSignIn')}
        </Button>
      </Form>
    </div>
  );
}
